"use client"

import { useState, useEffect } from "react"
import { useForm } from "react-hook-form"

type PopupMessage = {
  success: boolean
  message: string
}

export default function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [isSending, setIsSending] = useState(false);
  const [popupMessages, setPopupMessages] = useState<PopupMessage[]>([]);

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  const onSubmit = (data: any) => {
    if (isSending) return;
    setIsSending(true);
    fetch("https://sheetdb.io/api/v1/gn96dgh3lklsu", {
      method: "POST",
      body: JSON.stringify({ ...data, date: new Date().toISOString(), navigator: window.navigator.userAgent || "" }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(() => {
        setPopupMessages((prev) => [
          ...prev,
          { success: true, message: "✅ Message sent successfully!" },
        ]);
      })
      .catch(() => {
        setPopupMessages((prev) => [
          ...prev,
          { success: false, message: "❎ Message failed to send!" },
        ]);
      })
      .finally(() => {
        setIsSending(false);
        setTimeout(() => {
          setPopupMessages((prev) => prev.slice(1));
        }, 5000);
      });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="text-base font-sans h-fit w-full md:max-w-sm lg:max-w-md mx-auto md:mx-0 pointer-events-auto rounded-xl bg-dark3 border-2 border-light/5 p-6 md:p-8"
    >
      <h2 className="text-lg font-semibold mb-4 text-center text-light/90">
        Your Questions Are Always Welcome
      </h2>

      <div className="mb-2">
        <input
          type="text"
          id="name"
          placeholder="Name"
          {...register("name", { required: "Name is required" })}
          spellCheck={false}
          className="w-full p-2 text-sm rounded-lg focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent bg-dark3 border-2 border-light/5 placeholder:text-light/40"
        />
        {errors["name"] && (
          <span className="text-red-500 text-xs block">{errors["name"]?.message?.toString()}</span>
        )}
      </div>

      <div className="mb-2">
        <input
          type="email"
          id="email"
          placeholder="Email"
          {...register("email", {
            required: "Email is required",
            pattern: {
              value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
              message: "Invalid email address",
            },
          })}
          spellCheck={false}
          className="w-full p-2 text-sm rounded-lg focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent bg-dark3 border-2 border-light/5 placeholder:text-light/40"
        />
        {errors["email"] && (
          <span className="text-red-500 text-xs block">{errors["email"]?.message?.toString()}</span>
        )}
      </div>

      <div className="mb-5">
        <textarea
          id="message"
          placeholder="Message"
          rows={4}
          {...register("message", { required: "Please share some details about your project or question" })}
          className="w-full p-2 text-sm appearance-none min-h-16 max-h-80 rounded-lg focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent bg-dark3 border-2 border-light/5 placeholder:text-light/40"
        />
        {errors["message"] && (
          <span className="text-red-500 text-xs block">{errors["message"]?.message?.toString()}</span>
        )}
      </div>

      <input
        type="submit"
        value={isSending ? "Sending..." : "Send Message"}
        disabled={isSending}
        className="button-accent mt-4"
      />

      {popupMessages.length > 0 && (
        <div
          className="w-fit min-w-72 h-dvh fixed top-1/2 left-full transform -translate-x-full -translate-y-1/2 flex flex-col gap-0.5 items-end justify-end p-3"
          style={{ zIndex: 1000 }}
        >
          {popupMessages.map((popupMessage, index) => (
            <div
              key={index}
              className={`pointer-events-auto appear w-fit ${popupMessage.success === true ? "bg-green-500" : "bg-red-500"
                } text-white px-4 py-2 rounded-md shadow-lg`}
            >
              {popupMessage.message}
            </div>
          ))}
        </div>
      )}
    </form>
  );
}